import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

import { CalendarEventType } from '../calendar-event-type';
import { useEventCalendarViewState } from '../calendar-state';

const SEGMENTS: Array<{ value: CalendarEventType; label: string }> = [
    { value: 'client', label: 'Client' },
    { value: 'internal', label: 'Internal' },
];

// Radix single-select reports '' when the active segment is clicked again — nothing selected
// (null) means all events are shown, so there is no "All" segment.
export const EventCalendarTypeFilter = () => {
    const { eventCalendarViewState, setEventCalendarViewState } = useEventCalendarViewState();

    return (
        <ToggleGroup
            type="single"
            value={eventCalendarViewState.eventTypeFilter ?? ''}
            onValueChange={(value) =>
                setEventCalendarViewState({ eventTypeFilter: value === '' ? null : (value as CalendarEventType) })
            }
            className="border-cocoa-100 gap-2 rounded-full border bg-white p-1"
        >
            {SEGMENTS.map(({ value, label }) => (
                <ToggleGroupItem
                    key={value}
                    value={value}
                    className="text-cocoa-500 hover:bg-cocoa-100 hover:text-gold-500 data-[state=on]:bg-cocoa-800 data-[state=on]:text-primary-foreground data-[state=on]:hover:bg-cocoa-700 data-[state=on]:hover:text-primary-foreground h-8 rounded-full px-4 font-thin first:rounded-l-full last:rounded-r-full"
                >
                    {label}
                </ToggleGroupItem>
            ))}
        </ToggleGroup>
    );
};
